import type { MouseEvent, ReactNode } from 'react';
import { Link } from '@inertiajs/react';

import { useIsPreviewMode } from '@/hooks/use-is-preview-mode';
import { PREVIEW_NAV_MESSAGE } from '@/lib/page-utils';
import { postMessageToParent } from '@/lib/utils';

interface PageButtonLinkProps {
  href: string;
  internalPageId?: string;
  className?: string;
  children: ReactNode;
  preventNavigation?: boolean;
  onClick?: (event: MouseEvent<Element>) => void;
}

export function PageButtonLink({
  href,
  internalPageId,
  className,
  children,
  preventNavigation = false,
  onClick,
}: PageButtonLinkProps) {
  const isPreview = useIsPreviewMode();

  return (
    <Link
      href={href}
      className={className}
      onClick={(event) => {
        if (isPreview && internalPageId) {
          postMessageToParent({ type: PREVIEW_NAV_MESSAGE, pageId: internalPageId });
        }

        if (preventNavigation) {
          event.preventDefault();
        }

        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
